import ListDataLineChart from './list-data-line-chart';

export default ListDataLineChart;
